'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useIsMobile = require('../../../../common/providers/useIsMobile.js');
var OrderLookupMobile = require('./OrderLookupMobile.js');
var OrderLookupDesktop = require('./OrderLookupDesktop.js');
var useAnalytics = require('../../../../common/providers/useAnalytics.js');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const OrderLookup = () => {
  const isMobile = useIsMobile["default"]();
  const logEvent = useAnalytics["default"]();
  const titan = useTitanAnalytics["default"]();
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'Order Lookup'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ORDER_LOOKUP,
      page_step: useAnalytics.ClaimsPageStep.ORDER_LOOKUP
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isMobile ? /*#__PURE__*/React__default["default"].createElement(OrderLookupMobile["default"], null) : /*#__PURE__*/React__default["default"].createElement(OrderLookupDesktop["default"], null);
};

exports["default"] = OrderLookup;
